import { makeRequest } from "./api";

export const FetchSiteSettings = async () => {
  return makeRequest("/api/admin/siteSettings/fetch");
};

export const CreateSiteSetting = async (title, name, value) => {
  return makeRequest("/api/admin/siteSettings/create", {
    method: "POST",
    data: {
      title,
      name,
      value,
    },
  });
};

export const UpdateSiteSetting = async (siteSettingId, title, name, value) => {
  return makeRequest("/api/admin/siteSettings/update", {
    method: "PUT",
    data: {
      siteSettingId,
      title,
      name,
      value,
    },
  });
};

export const DeleteSiteSetting = async (siteSettingId) => {
  return makeRequest("/api/admin/siteSettings/remove", {
    method: "DELETE",
    data: {
      data: {
        siteSettingId,
      },
    },
  });
};
